import BuildingList from './building-list';
export default BuildingList;
